// extracted by mini-css-extract-plugin
module.exports = {"code":"Iframe_code__1BNuo","buttonPanel":"Iframe_buttonPanel__1pB06","button":"Iframe_button__GSMXk","active":"Iframe_active__3-3N6"};